module.exports = __webpack_public_path__ + "img/VP-ECO13_Overview-Front_1.56dd8a82.jpg";